import * as React from 'react'

import {
  Input,
  Button,
  InputGroup,
  InputGroupAddon
} from 'reactstrap'
import Autocomplete from 'react-autocomplete'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type NavSearchProps = {
  style?: any
  value?: string
  className?: string
  isLoading?: boolean
  suggestions?: any[]
  enableSuggestions?: boolean
  onChange: (value: string) => void
  onSelect?: (value: any, item: any) => void
  renderSuggestion?: (item: any, isHighlighted: boolean) => void
}

class NavSearch extends React.PureComponent<NavSearchProps> {
  get suggestionsMenuStyle() {
    const { style } = this.props
    return {
      ...style,
      zIndex: 1000,
      fontSize: '90%',
      padding: '2px 0',
      overflowY: 'auto',
      maxHeight: '50%',
      position: 'fixed',
      overflowX: 'hidden',
      background: 'white',
      borderRadius: '3px',
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)'
    }
  }

  renderAutocompleteInput() {
    const { value, onChange, onSelect, suggestions, renderSuggestion } = this.props
    
    return (
      <Autocomplete
        value={value}
        onSelect={onSelect}
        items={suggestions || []}
        renderItem={renderSuggestion}
        wrapperStyle={{ flexGrow: 1 }}
        getItemValue={item => `${item.id}`}
        menuStyle={this.suggestionsMenuStyle}
        onChange={e => onChange(e.target.value || '')}
        inputProps={{ placeholder: 'Type to search' }}
        renderInput={({ ref, ...rest }) => (
          <Input
            {...rest}
            innerRef={ref}
          />
        )}
      />
    )
  }


  render() {
    const { style, value, onChange, isLoading, className, enableSuggestions } = this.props

    return (
      <InputGroup id="ggnavsearch" style={style} className={className}>
        {enableSuggestions
          ? this.renderAutocompleteInput()
          : (
            <Input
              value={value}
              placeholder="Type to search"
              onChange={e => onChange(e.target.value || '')}
            />
          )
        }
        <InputGroupAddon addonType="append">
          <Button color="primary" type={isLoading? 'button' : 'submit'}>
            {isLoading
              ? <FontAwesomeIcon spin icon={['fas', 'spinner']} />
              : <FontAwesomeIcon icon="search" />
            }
          </Button>
        </InputGroupAddon>
      </InputGroup>
    )
  }
}

export default NavSearch



// WEBPACK FOOTER //
// ./src/routes/NavSearch.component.tsx